import { useState } from 'react';
import { CompletionButton, Text } from 'shell/components';

const CompletionButtonDemo = () => {
    const [button1, setButton1] = useState(false);
    const [button2, setButton2] = useState(true);

    return (
        <>
            <Text variant={'sh1'}>CompletionButton</Text>
            <CompletionButton checked={button1} onClick={() => setButton1((current) => !current)} />
            <CompletionButton checked={button2} onClick={() => setButton2((current) => !current)} />
            <CompletionButton checked={button1} />
            <CompletionButton checked={button2} />
        </>
    );
};

export default CompletionButtonDemo;
